import AlertUtility from '@/util/AlertUtility';
import Utility from '@/util/Utility';
import INavigationController from '../INavigationController';
import NavigationContext from './NavigationContext';
import NavigationStateDisplayType from './NavigationStateDisplayType';

abstract class AbstractNavigationState {
  protected readonly navigationController: INavigationController;
  protected readonly navigationContext: NavigationContext;
  protected readonly lockSectionsEnabled: boolean;
  constructor(
    navigationController: INavigationController,
    navigationContext: NavigationContext,
    lockSectionsEnabled: boolean
  ) {
    this.navigationController = navigationController;
    this.navigationContext = navigationContext;
    this.lockSectionsEnabled = lockSectionsEnabled;
  }

  abstract handleForwardNavigation(navigationCallback: (NavigationCallbackType) => void): void;

  abstract handleBackNavigation(navigationCallback: (NavigationCallbackType) => void): void;

  abstract handleCurrentItemNavigation(navigationCallback: (NavigationCallbackType) => void): void;

  abstract handleReviewSubmit(navigationCallback: (NavigationCallbackType) => void): void;

  abstract getDisplayType(): NavigationStateDisplayType;

  abstract getLocationState(): number;

  protected displayIncompleteAlert(
    incompleteCount: number,
    flaggedCount: number,
    reviewSubmit: boolean,
    callbackFunction: () => void,
    processingFunction: (() => void) | null
  ): void {
    const i18n = (window as any).i18n.global;
    let message1 = i18n.t('modal.questions_complete');
    let message2 = i18n.t('modal.continue_confirm');
    let title = i18n.t('review.continue');
    let okButton = i18n.t('btn.continue');
    let inComplete = false;
    const endOfTest = reviewSubmit || this.navigationController.lastSectionInTest();

    if (endOfTest) {
      title = i18n.t('modal.submit_header');
      okButton = i18n.t('btn.submit');
      message2 = i18n.t('modal.submit_confirm');
    }

    if (incompleteCount + flaggedCount > 0) {
      message1 = Utility.getIncompleteAndFlaggedText(incompleteCount, flaggedCount, null, null);
      inComplete = true;
      if (endOfTest) {
        message2 = i18n.t('modal.emphasize_submit_confirm');
      }
    }

    if (!endOfTest && this.lockSectionsEnabled) {
      message2 = message2 + ' ' + i18n.t('review.continue_msg');
    }

    if (!endOfTest && this.navigationController?.sectionLogout()) {
      title = i18n.t('modal.section_logout');
      if (inComplete) {
        message1 = message1 + ' ' + i18n.t('modal.continue_info_2');
        message2 = '';
      } else {
        message1 = message1 + ' ' + i18n.t('modal.continue_info_1');
        message2 = '';
      }
    }

    AlertUtility.displayQuestionDialogWithCustomButtonText(
      title,
      message1 + ' ' + message2,
      i18n.t('btn.cancel'),
      okButton
    )
      .then(() => {
        if (processingFunction) {
          processingFunction();
        }
        callbackFunction();
      })
      .catch(() => {
        //Do nothing;
      });
  }
}

export default AbstractNavigationState;
